<!-- 面包屑  -->
<template>
  <a-breadcrumb separator=">">
    <a-breadcrumb-item v-for="item in routeList" :key="item.path">
      {{item.title}}
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>

<script>
export default {
  name: "breadcrumb",
  props:{
    routes:{
      type:Array,
      require:true
    }
  },
  data() {
    return {
      routeList:[]
    };
  },
  methods: {},
  computed: {},
  watch: {},
  created() {
    console.log('组件传参',this.routes)
    this.routeList = this.routes.map((item) => {
      return {
        path: item.path,
        title: item.meta.title,
      };
    });
  },
  mounted() {
    
  },
};
</script>

<style lang="scss" scoped></style>
